(() => {
  const dialog = document.querySelector('[data-trailer]');
  if (!dialog) return;
  const frame = dialog.querySelector('[data-trailer-frame]');
  const open = (id) => {
    if (typeof dialog.showModal !== 'function') {
      window.open(`https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}`, '_blank', 'noopener');
      return;
    }
    frame.innerHTML = `<iframe src="https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0&modestbranding=1" allow="autoplay; fullscreen" allowfullscreen title="Trailer"></iframe>`;
    dialog.showModal();
  };
  const close = () => { dialog.close(); };
  dialog.addEventListener('close', () => { frame.innerHTML = ''; });
  dialog.querySelector('[data-trailer-close]').addEventListener('click', close);
  dialog.addEventListener('click', (e) => { if (e.target === dialog) close(); });
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-trailer-open]');
    if (btn && btn.dataset.youtubeId) open(btn.dataset.youtubeId);
  });
})();
